export default __webpack_public_path__ + "static/media/smartplan_navicon-light.254b219d.svg";